"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BannerAdStyles = void 0;
const merge = require("deepmerge"),
  BannerAdStyles = (theme, variant, image) => {
    let result = {};
    if (variant === "backgroundImageAd") {
      result = merge(theme.mixins.container.outer, {
        backgroundImage: `url(${image})`,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        padding: {
          xs: "0 2.5rem",
          md: "0 4rem"
        },
        ".bannerAd__inner": merge(theme.mixins.container.inner, {
          color: "#FFFFFF",
          flexDirect: "column",
          padding: "12rem 0",
          textAlign: "center",
          "h1, h2, h3, h4, h5, h6": merge(theme.mixins.headings.InteriorPageSubHeading.content, {
            color: "#FFFFFF",
            fontSize: {
              xs: "2.6rem",
              md: "3.2rem"
            }
          }),
          "a": {
            marginTop: "4rem"
          }
        })
      });
    } else if (variant === "imageSplitAd") {
      result = merge(theme.mixins.container.outer, {
        backgroundColor: theme.palette.background.ad,
        padding: {
          xs: "0 2.5rem",
          md: "0 4rem"
        },
        ".bannerAd__inner": merge(theme.mixins.container.inner, {
          padding: "5rem 0",
          display: "flex",
          alignItems: "center",
          flexDirection: {
            xs: "column",
            sm: "column",
            md: "row"
          },
          textAlign: {
            xs: "center",
            sm: "center",
            md: "left"
          },
          ".bannerAd__image": {
            backgroundImage: `url(${image})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            flex: 1,
            minHeight: "250px",
            width: "100%"
          },
          ".bannerAd__content": {
            flex: 1,
            paddingLeft: {
              sm: 0,
              md: "4rem"
            },
            paddingTop: {
              sm: "2rem",
              md: 0
            },
            "h1, h2, h3, h4, h5, h6": merge(theme.mixins.headings.InteriorPageSubHeading.content, {
              textAlign: {
                sm: "center",
                md: "left"
              },
              fontSize: {
                xs: "2.6rem",
                md: "3.2rem"
              }
            }),
            "a": {
              marginTop: "2rem"
            }
          }
        })
      });
    } else if (variant === "splitAd") {
      result = merge(theme.mixins.container.outer, {
        backgroundColor: theme.palette.background.ad,
        padding: {
          xs: "0 2.5rem",
          md: "0 4rem"
        },
        textAlign: {
          xs: "center",
          sm: "center",
          md: "left"
        },
        ".bannerAd__inner": merge(theme.mixins.container.inner, {
          padding: "5rem 0",
          "h1, h2, h3, h4, h5, h6": merge(theme.mixins.headings.InteriorPageSubHeading.content, {
            textAlign: {
              xs: "center",
              sm: "center",
              md: "left"
            },
            fontSize: {
              xs: "2.6rem",
              md: "3.2rem"
            }
          }),
          ".bannerAd__content": {
            display: "flex",
            alignItems: "center",
            flexDirection: {
              xs: "column",
              sm: "column",
              md: "row"
            },
            justifyContent: "space-between",
            "div": {
              maxWidth: {
                xs: "100%",
                sm: "100%",
                md: "70%"
              }
            },
            "a": {
              marginTop: "2rem"
            }
          }
        })
      });
    }
    return result;
  };
exports.BannerAdStyles = BannerAdStyles;